import { render } from 'base/wrapped-render';
import { renderV2 } from 'base/wrapped-render-v2';
import { ifFeature } from '@bamboohr/utils/lib/feature';
import AddEditEntry from './add-edit-entry.react';
import './styles.styl';

export default function (data) {
	return new Promise((resolve) => {
		let title = $.__('Time Worked');
		if (data.canEdit) {
			title = data.type === 'edit' ? $.__('Edit Time Worked') : $.__('Enter Time Worked');
		}

		const attachedElement = document.createElement('div');
		const children = <AddEditEntry { ...data } afterAction={ resolve } modalTitle={ title } />;

		const renderer = ifFeature(
			'REACT_18_TT_MIGRATION',
			() => renderV2({ children, attachedElement }),
			() => render(children, attachedElement)
		);

		renderer();
	});
}
